import * as mainTerms from '../mainTerms';

const req = mainTerms.Other.request;
const imp = mainTerms.Other.impression;
const impRate= mainTerms.Other.impRate;
const creative = mainTerms.Other.creative;
const ssp = mainTerms.Other.ssp;
const adserver = mainTerms.Other.defaultTitle;
const inventoryDef = mainTerms.Setting.inventory.default;
const partnerDef = mainTerms.Setting.partner.default;
const advertiserDef = mainTerms.Setting.advertiser.default;
export const column = {
    status: '상태',
    explain: '설명',
    app: '앱',
    inventory: inventoryDef,
    type: '타입',
    format: '지원 포맷',
    creative: creative,
    price: '단가',
    impression: imp + ' 수',
    click: '클릭',
    ctr: 'CTR',
    totalBudget: '총 예산',
    dailyBudget: '일 예산',
    spentBudget: '소진한 예산',
    totalSales: '전체 매출',
    sspSales: ssp + ' 매출',
    adServerSales: adserver + ' 매출',
    eachSales: advertiserDef + ' 별 매출',
    totalRequest: '전체 ' + req,
    adServerRequest: adserver + ' 유료',
    adServerFreeRequest: adserver + ' 무료',
    sspRequest: ssp,
    totalImp: '전체 ' + imp,
    adServerImp: adserver + ' 유료',
    adServerFreeImp: adserver + ' 무료',
    adServerImpRate: adserver + ' 유료 '+impRate,
    sspImp: ssp,
    sspBaseFormat: '기준 비율',
    revenue: '매출',
    date: '날짜',
    beginDate: '시작일',
    endDate: '종료일',
    createdDate: '생성일',
    partner: partnerDef,
    advertiser: advertiserDef,
    platform: '플랫폼',
    scale: '규모',
    audienceCount: '규모',
    impWeight: imp + ' 가중치',
    key: 'Key',
    campaignNum: mainTerms.Setting.campaign.default + ' 수',
    adsetNum: mainTerms.Setting.adset.default + ' 수',
    adNum: mainTerms.Setting.ad.default + ' 수',
    campaign: {
        name: mainTerms.Setting.campaign.default + ' 명',
    },
    adset: {
        name: mainTerms.Setting.adset.default + ' 명',
    },
    ad: {
        adsetAsInventory: mainTerms.Setting.inventory.default,
        name: mainTerms.Setting.ad.default + ' 명',
        id: mainTerms.Setting.ad.default + ' ID',
    },
    audience: {
        name: mainTerms.Setting.audience.default + ' 명',
    },
    adFolder: {
        name: mainTerms.Setting.adFolder.default + ' 명',
        campaignNum: '연결된 ' + mainTerms.Setting.campaign.default + ' 수',
        adsetNum: '연결된 ' + mainTerms.Setting.adset.default + ' 수',
    },
    report: {
        inventory: {
            name: '이름 (앱, ' + inventoryDef + ')',
        }
    }
}